import axios from "axios";
import router from "./router";
import Element from "element-ui"

axios.defaults.baseURL = "https://www.meliinfo.cn/milistboot/"
// axios.defaults.baseURL="http://192.168.0.151:8080/milistboot/"
const request = axios.create({
    timeout: 15000,
    headers: {
        'Content-Type': "application/json; charset=utf-8"
    }
})

request.interceptors.request.use(config => {
    config.headers['face_token'] = localStorage.getItem("face_token")
	config.headers['tenant-id'] = localStorage.getItem("tenantId")
			// console.log('tenant-id',config.headers['tenant-id'])
    return config
})

request.interceptors.response.use(
    response => {
        if (response.data.code === 200 || response.data.code === 201 || response.data.code === 0){
            return response
        }else {
			return response
            // Element.Message.error(response.data.msg, {duration: 3000})
            // return Promise.reject(response.data.msg)
        }
    },
    error => {
        Element.Message.error(error.msg, {duration: 3000})
        return Promise.reject(error)
    }
)

export default request